<div class="container">
  <p>&nbsp;</p>
  <p>
  <div v-if="hasErrored" class="alert alert-danger">
    {{validationErrors}}
    <ul>
      <li v-for="item in listErrors" :key="listErrors.description">
        {{ item.description }}
      </li>
    </ul>
  </div>
  </p>
  <div class="col-md-12">
    <div class="col-md-6 col-md-offset-4">
      <div class="panel panel-default">
        <div class="panel-body">
          <form action="post">
            <div class="text-center">
              <h3><i class="fa fa-lock fa-4x"></i></h3>
              <h2 class="text-center">Forgot Password?</h2>
              <p>You can reset your password here.</p>
              <div class="panel-body">

                <div class="form-group">

                  <input v-model="password" placeholder="Password" class="form-control" type="password">
                </div>
                <div class="form-group">
                  <input v-model="confirm" placeholder="Confirm Password" class="form-control" type="password">

                </div>
                <div class="form-group">
                  <input type="button" class="btn btn-lg btn-primary btn-block" value="Reset Password"
                    @click="sendPasswordReset">
                </div>
                <p>&nbsp;</p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>